import { getRTPCapabilites } from "./handleGetRTPCapabilites.js";
export const emitEvents = () => {
  getRTPCapabilites();
};
